// @flow
import React, { useEffect } from 'react';
import cn from 'classnames';

// import { CAN_USE_DOM } from 'common/constants';

import * as css from './GoogleAds.scss';

type Props = {
	id: string,
	path: string,
	size: number[],
	className?: string,
};

const GoogleAds = ({ id, path, size, className }: Props) => {
	useEffect(() => {
		if (path && size && id) {
			useDfpSlot(path, size, id);
		}
	}, []);

	const useDfpSlot = (pathVal, sizeVal, idVal) => {
		const googletag = window.googletag || {};
		googletag.cmd = googletag.cmd || [];
		googletag.cmd.push(function createSlot() {
			googletag.defineSlot(pathVal, sizeVal, idVal).addService(googletag.pubads());
			googletag.pubads().enableSingleRequest();
			googletag.enableServices();
		});
		googletag.cmd.push(function displayAds() {
			googletag.display(idVal);
		});

		// let slideBannerTimeoutID = null;
		// googletag.pubads().addEventListener('slotRenderEnded', event => {
		// 	if (!CAN_USE_DOM) {
		// 		return false;
		// 	}
		// 	slideBannerTimeoutID = setTimeout(() => {
		// 		const el = document.getElementById(`google_ads_iframe_${idVal}_0`).contentWindow;
		// 		const link = document.createElement('link');
		// 		link.href = 'https://livegame.ynet.co.il/assets/client/iframe-styles.css';
		// 		link.rel = 'stylesheet';
		// 		link.type = 'text/css';
		// 		el.document.head.appendChild(link);
		// 	}, 5000);
		// });

		// clearTimeout(slideBannerTimeoutID);
	};

	return <div id={id} style={{ width: '100%', height: `${size[1]}px` }} className={cn(className, css.googleAds)} />;
};

GoogleAds.defaultProps = {
	className: '',
};

export { GoogleAds };
